export const USER_REQUEST = 'USER_REQUEST';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_ERROR = 'USER_ERROR';
export const USER_FB_TOKEN_REQUEST = 'USER_FB_TOKEN_REQUEST';
export const USER_FB_TOKEN_SUCCESS = 'USER_FB_TOKEN_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/actions/user.js